<template>
    <div>
<!--        <div v-if="serverResponse">-->
<!--            <h6 class="red&#45;&#45;text ">Network Error</h6>-->
<!--        </div>-->
      <v-row>
          <v-card
                      class="summary-bck "
                      width="880"
                      height="120"
              >
                  <v-card-text>
                      <div class="summary-heading mt-1">Progress</div>
                      <v-row>
                          <v-col col="sm-4">
                               <p class="summary-label font-weight-bold">Application Status: {{this.applicant.applicationStatus}}</p>
                          </v-col>
                          <v-col col="sm-4">
                              <p class="summary-label">Tuition Paid: NGN {{this.applicant.tuitionPaid}}</p>

                          </v-col>
                      </v-row>
                  </v-card-text>
          </v-card>
          <v-row>
              <v-col col="sm-6">
                  <v-card
                          class="summary-bck"
                          width=""
                          height="280"
                  >
                      <v-card-text class="ml-3">
                          <div  class="summary-heading">Bio</div>
<!--                          <div v-for="(applican,index) in applicant" :key="index">-->
<!--                              <p v-if="applicant[index]===''">Undefined</p>-->
<!--                          </div>-->
                          <v-row>
                              <v-col col="sm-6">
                                  <p class="summary-label">First Name</p>
                                  <p class="summary-info">{{this.applicant.firstName}}</p>
                              </v-col>
                              <v-col col="sm-6">
                                  <p class="summary-label">Last Name</p>
                                  <p class="summary-info">{{this.applicant.lastName}}</p>

                              </v-col>
                          </v-row>
                          <v-row>

                              <v-col col="sm-12">
                                  <p class="summary-label">Email Address</p>
                                  <p class="summary-info">{{this.applicant.applicantDocument.email}}</p>

                              </v-col>
                          </v-row>
                          <v-row>
                              <v-col col="sm-6">
                                  <p class="summary-label">Gender</p>
                                  <p class="summary-info">{{this.applicant.gender}}</p>
                              </v-col>
                              <v-col col="sm-6">
                                  <p class="summary-label">Age</p>
                                  <p class="summary-info">{{convertDate}}</p>

                              </v-col>
                          </v-row>

                      </v-card-text>
                  </v-card>

              </v-col>
              <v-col col="sm-6">
                  <v-card
                          class="summary-bck ml-3"
                          width=""
                          height="280"
                  >

                      <v-card-text>
                          <div  class="summary-heading">More info</div>
                          <v-row>
                              <v-col col="sm-6">
                                  <p class="summary-label"> State of Origin </p>
                                  <p v-if="this.applicant.applicantDocument.questionnaire.stateOfOrigin===''" class="summary-info">NOT_APPLICABLE</p>
                                  <p v-else class="summary-info">{{this.applicant.applicantDocument.questionnaire.stateOfOrigin}}</p>
                              </v-col>
                              <v-col col="sm-6">
                                  <p class="summary-label"> State of Residence</p>
                                  <p v-if="this.applicant.applicantDocument.questionnaire.stateOfResidence===''" class="summary-info">NOT_APPLICABLE</p>
                                  <p v-else class="summary-info">{{this.applicant.applicantDocument.questionnaire.stateOfResidence}}</p>

                              </v-col>
                          </v-row>
                          <v-row>
                              <v-col col="sm-6">
                                  <p class="summary-label"> Higher Institution </p>
                                  <p v-if="this.applicant.applicantDocument.questionnaire.underGradInstitution===''" class="summary-info">NOT_APPLICABLE</p>
                                  <p v-else class="summary-info">{{this.applicant.applicantDocument.questionnaire.underGradInstitution}}</p>
                              </v-col>
                              <v-col col="sm-6">
                                  <p class="summary-label">Course of Study</p>
                                  <p v-if="this.applicant.applicantDocument.questionnaire.underGradCourse===''" class="summary-info">NOT_APPLICABLE</p>
                                  <p v-else class="summary-info">{{this.applicant.applicantDocument.questionnaire.underGradCourse}}</p>

                              </v-col>
                          </v-row>
                          <v-row>
                              <v-col col="sm-6">
                                  <p class="summary-label">  University Grade</p>
                                  <p v-if="this.applicant.applicantDocument.questionnaire.underGradGrade===''" class="summary-info">NOT_APPLICABLE</p>
                                  <p v-else class="summary-info">{{this.applicant.applicantDocument.questionnaire.underGradGrade}}</p>
                              </v-col>
                              <v-col col="sm-6">
                                  <p class="summary-label">Marital Status</p>
                                  <p v-if="this.applicant.applicantDocument.questionnaire.maritalStatus===''" class="summary-info">NOT_APPLICABLE</p>
                                  <p v-else class="summary-info">{{this.applicant.applicantDocument.questionnaire.maritalStatus}}</p>

                              </v-col>
                          </v-row>
                      </v-card-text>
                  </v-card>

              </v-col>


          </v-row>



      </v-row>
    </div>
</template>

<script>


    import {mapGetters} from "vuex";

    export default {
        name: "Summary",
        data(){
            return{
                convertDate:'',
                applicantDataValue:'',
                applicantDataLabel:''
            }
        },

        computed: mapGetters([
            'applicant',
            'serverResponse'
        ]),
        updated() {
         //   let dateOfBirth = this.applicant.applicantDocument.questionnaire.dateOfBirth;
         //    this.convertDate = new Date().getFullYear() - dateOfBirth.toString().substr(0,4)
            this.convertDate = this.calculateAge();

            this.applicantDataLabel = Object.keys(this.applicant.applicantDocument.questionnaire)
            this.applicantDataValue = Object.values(this.applicant.applicantDocument.questionnaire)

        },




      methods: {
        calculateAge () {
          let serverDateOfBirth = this.applicant.applicantDocument.questionnaire.dateOfBirth;
          console.log(serverDateOfBirth)

          if (serverDateOfBirth === undefined) return;
          let arrAge = serverDateOfBirth.split('-');
          let [year, month, day] = arrAge;


          month = --month; //month counts from zero and not one, decrementing by one consolidates it

          let dateOfBirth = new Date(Number(year), Number(month), Number(day));
          let currentDate = new Date();

          let currentAge = currentDate.getFullYear() - dateOfBirth.getFullYear();
          let monthDifference = currentDate.getMonth() - dateOfBirth.getMonth();

          if (monthDifference < 0 || (monthDifference === 0 && currentDate.getDate() < dateOfBirth.getDate())) {
            currentAge--;
          }
          return currentAge;
        }


      }

    }

</script>

<style scoped>
    .summary-bck{
        background: #FFF2C7;
        border-radius: 16px;
        margin-bottom: 20px;
    }
    .summary-heading{
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: bold;
        font-size: 21px;
        line-height: 27px;
        display: flex;
        align-items: center;
        letter-spacing: -0.02em;
        color: #960C0C;
    }
    p{
        margin-bottom: 7px !important;
    }
    .summary-label{
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        margin-left: 7px;
        display: flex;
        align-items: center;
        letter-spacing: 0.05em;
        color: #2B1C1C;
    }
    div.col{
        padding: 5px !important;
    }
    .summary-info{
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        margin-left: 7px !important;
        line-height: 18px;
        display: flex;
        align-items: center;
        letter-spacing: 0.05em;
        color: #2B1C1C;


    }

</style>